<!--
    描述： Pending.vue
    创建时间： 2022-05-10 09:28:12
    作者： Wang Shuai
    邮箱： 591372242@qq.com
-->
<template>
	<div class="ahCnter">
		<img :src="require(`static/images/developing.png`)"
			 alt="开发中">
        <p class="text-center tips">{{ desc }}</p>
	</div>
</template>

<script>
export default {
	name: '',
	props: {
		// 描述性文字
		desc: {
			type: String,
			default: '功能待开发'
		}
	},
	data() {
		return {}
	},
	methods: {},
}
</script>

<style scoped lang="less">
.ahCnter {
    height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
    flex-direction: column;
    background-color: #fff;
	img {
		width: 400px;
	}
    .tips {
        color: #666;
        font-size: 16px;
        margin-top: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pending/Pending.vue